/* global femcare */

femcare.product.productList = {
    breakpoint: window.matchMedia('(min-width: 992px)'),

    init: function () {
        this.setSsameHeights();
        this.breakpoint.addEventListener('change', this.setSsameHeights.bind(this));
    },

    setSsameHeights: function(){
        this.$productList = $('.product-list');

        if (this.$productList.length) {
            this.$items = this.$productList.find('.product-list__item');

            this.$back = this.$productList.find('.product-list-back');

            $('.product-filter').on('filter', this.onFilter.bind(this));
        }
    },

    onFilter: function (event, data) {
        var rules = data.rules;
        this.$items.add(this.$back).hide();

        if (!rules || rules.length === 0) {
            this.$items.add(this.$back).fadeIn();
        } else {
            for (var itemIndex = 0; itemIndex < this.$items.length; itemIndex++) {
                var item = this.$items[itemIndex];
                var isMatch = false;

                for (var ruleIndex = 0; ruleIndex < rules.length; ruleIndex++) {
                    var rule = rules[ruleIndex];

                    var selectorAttributes = [];
                    for (var optionIndex = 0; optionIndex < rule.length; optionIndex++) {
                        var category = rule[optionIndex].category;
                        var option = rule[optionIndex].option;
                        selectorAttributes.push('data-' + category + '-' + option);
                    }

                    if (this.satisfiesAllCriteria(item, selectorAttributes)) {
                        isMatch = true;
                        break;
                    }
                }

                if (isMatch) {
                    $(item).fadeIn();
                }
            }

            this.$back.fadeIn();
        }
    },

    satisfiesAllCriteria: function (item, attributes) {
        var satisfiesCriteria = true;

        for (var index = 0; index < attributes.length; index++) {
            satisfiesCriteria = satisfiesCriteria && item.hasAttribute(attributes[index]);
        }

        return satisfiesCriteria;
    }
};
